import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { MessageService } from 'primeng/api'
import {
  GlobalSettingsService,
  TwoFactorService,
} from '../../../../api/services'
import { validateAllFormFields } from '../../../../formUtils'

@Component({
  selector: 'app-cellverification',
  templateUrl: './cellverification.component.html',
  styleUrls: ['./cellverification.component.css'],
})
export class CellverificationComponent implements OnInit {
  CellVerification2F: UntypedFormGroup
  errorValidationSummary: string = ''
  ShowErrorSummary: boolean = false
  cellVerfButton: boolean = true
  OtpVerfButton: boolean = false
  HeaderBarText: string = 'Please verify your cell number'
  keydata: string = ''
  cellOkButton: boolean = false

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private globalsettingService: GlobalSettingsService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private twofac: TwoFactorService,
  ) {}

  ngOnInit(): void {
    this.CellVerification2F = this.fb.group({
      cellNo: ['', Validators.required],
      Otp: ['', null],
    })
  }
  VerifyCellno(): void {
    validateAllFormFields(this.CellVerification2F)

    var regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im

    if (regex.test(this.CellVerification2F.controls['cellNo'].value) == false) {
      this.messageService.add({
        key: 'alertToast',
        severity: 'error',
        summary: 'ERROR',
        detail: 'In Valid Number',
        life: 5000,
      })
      return
    }
    this.twofac
      .twoFactorCellverification({
        cellNo: this.CellVerification2F.controls['cellNo'].value,
      })
      .subscribe((res) => {
        var ret = res.split('||')

        if (ret.length > 1) {
          this.keydata = ret[1]
        }

        this.ShowErrorSummary = true
        this.errorValidationSummary = ret[0]

        if (res.indexOf('Error') > -1) {
          this.cellVerfButton = true
          this.OtpVerfButton = false
          this.HeaderBarText = 'Please verify your cell number'
        } else {
          this.cellVerfButton = false
          this.OtpVerfButton = true
          this.HeaderBarText = 'Please Enter Security Code For Verification'
        }
      })
  }

  VeifyToken(): void {
    this.twofac
      .twoFactorTokenverification({
        OTPNo: this.CellVerification2F.controls['Otp'].value,
        Key: this.keydata,
      })
      .subscribe((res) => {
        this.ShowErrorSummary = true
        this.errorValidationSummary = res

        if (res.indexOf('Error') > -1) {
          this.cellVerfButton = false
          this.OtpVerfButton = true
          this.cellOkButton = false
        } else {
          if (res.indexOf('sucessfull') > -1) {
            this.cellVerfButton = false
            this.OtpVerfButton = false
            this.cellOkButton = true
          } else if (res.indexOf('Invalid') > -1) {
            this.cellVerfButton = false
            this.OtpVerfButton = true
            this.cellOkButton = false
          }
        }
      })
  }
}
